"use strict";

exports.__esModule = true;
exports.DeviceGridElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _DeviceGridElement = require("./DeviceGridElement.legacy");
var _DeviceGridElement2 = require("./DeviceGridElement.modern");
// Flag-gated UI: `DeviceGridElement.legacy` is the component as it is on master,
// `DeviceGridElement.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var DeviceGridElement = exports.DeviceGridElement = (0, _uiSwitch.uiSwitch)(_DeviceGridElement.DeviceGridElement, _DeviceGridElement2.DeviceGridElement, "DeviceGridElement");